import { USER_LOGGED_OUT, GET_LOGGED_USER, CHANGE_PASSWORD, UPDATE_PROFILE } from "../actions/index";
import _ from 'lodash';

let logged_user = JSON.parse(localStorage.getItem('logged_user')) || null;

export default function (state = logged_user, action) {
    switch (action.type) {
        case GET_LOGGED_USER:
            localStorage.setItem('logged_user', JSON.stringify(action.payload));
            logged_user=action.payload;
            return action.payload;
        case USER_LOGGED_OUT:
            localStorage.removeItem('logged_user');
            return null;
        case CHANGE_PASSWORD:
             let logged_user = JSON.parse(localStorage.getItem('logged_user'))
             return logged_user
        case UPDATE_PROFILE:
             _.remove(state, { id: action.payload.id });
            localStorage.removeItem('logged_user');
            localStorage.setItem('logged_user', JSON.stringify(action.payload));
            logged_user=action.payload;
            return action.payload;
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/logged_user.js